export const iconFontAwesomeShoppingTags = (
	<i className="fa-solid fa-tags"></i>
);
